import React, { useEffect } from 'react'
import { GoalId, UserProfileDto, UserId } from '../../services/api.types'
import {
  Chat,
  Channel,
  MessageInput,
  MessageList,
  Thread,
  Window,
  useChannelActionContext,
  MessageToSend,
  AttachmentProps,
  Attachment,
  ImageProps,
  ImageComponent,
  GalleryProps,
  Gallery,
  ChannelHeader,
} from 'stream-chat-react'
import 'stream-chat-react/dist/css/index.css'
//import 'stream-chat-react/dist/css/v2/index.css'
import './ChallengeChat.scss'
import { getFullName } from '../../common/helpers/translations'
//import { CustomAvatar } from './components/CustomAvatar/CustomAvatar'
import { CustomChannelHeader } from './components/CustomChannelHeader/CustomChannelHeader'
import Loader from '../../components/Loader/Loader'
import { useInitChat } from './hooks/useInitChat'
import i18nInstance from './i18n/i18nInstance'

export interface IChallengeChatProps {
  goalId: GoalId
  userDto: UserProfileDto
}

const ChannelInner = ({ userId }: { userId: UserId }) => {
  const { sendMessage } = useChannelActionContext()

  const overrideSubmitHandler = (message: MessageToSend, cid: string) => {
    sendMessage(message)
    // Focus on input to show the keyboard.
    const el = document.getElementsByClassName('str-chat__textarea__textarea')
    if (el && el[0]) {
      // @ts-ignore
      el[0].focus()
    }
  }

  return (
    <>
      <Window>
        <CustomChannelHeader userId={userId} />
        <MessageList disableQuotedMessages hideDeletedMessages closeReactionSelectorOnClick onlySenderCanEdit />
        <MessageInput overrideSubmitHandler={overrideSubmitHandler} />
      </Window>
      <Thread />
    </>
  )
}

export default function ChallengeChat(props: IChallengeChatProps) {
  const { userDto, goalId }: { userDto: UserProfileDto; goalId: GoalId } = props
  const { userId, firstName, lastName, email } = userDto
  const name = getFullName(firstName, lastName, email)
  const { chatClient, currentChannel } = useInitChat(userId, name, goalId)

  if (!chatClient) return <Loader top={true} />

  //const CustomAvatar = () => <Initials fullName={name} size="sm" />

  /*const CustomImage: React.FC<ImageProps> = (props) => {
    /!*return <Attachment {...props} Gallery={CustomGallery} />*!/
    return (
      <ImageComponent
        {...props}
        thumb_url={
          'https://github.com/GetStream/stream-chat-react/blob/master/src/components/Attachment/Attachment.tsx'
        }
      />
    )
  }*/
  /*const CustomGallery: React.FC<GalleryProps> = (props) => {
    /!*return <Attachment {...props} Gallery={CustomGallery} />*!/
    console.log(props)

    const images = props.images.map((image) => {
      return { ...image, thumb_url: 'https://storage.googleapis.com/yumuuv-logos/calor-ireland.png' }
    })
    console.log(images)

    return <Gallery {...props} images={images} />
  }

  const CustomAttachment: React.FC<AttachmentProps> = (props) => {
    /!*return <Attachment {...props} Gallery={CustomGallery} />*!/
    return <Attachment {...props} Gallery={CustomGallery} />
  }*/

  return (
    <>
      <Chat client={chatClient} i18nInstance={i18nInstance}>
        {/*<Channel channel={currentChannel} Avatar={CustomAvatar} acceptedFiles={['image/*']}>*/}
        {/*<Channel Attachment={CustomAttachment} channel={currentChannel} acceptedFiles={['image/*']}>*/}
        <Channel channel={currentChannel} acceptedFiles={['image/*']}>
          <ChannelInner userId={userId} />
          {/*<Window>
            <ChannelHeader />
            <MessageList />
            <MessageInput />
          </Window>*/}
        </Channel>
      </Chat>
      {/*<Chat client={chatClient} i18nInstance={i18nInstance}>
        <Channel channel={currentChannel}>
          <Window>
            <ChannelHeader />
            <MessageList />
            <MessageInput />
          </Window>
          <Thread />
        </Channel>
      </Chat>*/}
    </>
  )
}
